export default function Button({
    children,
    type = "button",
    onClick,
    variant = "primary", // accepts 'primary', 'secondary', 'danger', etc. plain
    size = "md",          // accepts 'sm', 'md', 'lg'
    className = "",       // additional classes if needed
  }) {
    const base = "font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2";
    
    const variantClasses = {
      primary: "bg-primary text-black hover:bg-primaryDark focus:ring-primary",
      secondary: "bg-secondary text-black hover:bg-secondaryDark focus:ring-secondary",
      danger: "bg-danger text-black hover:bg-dangerDark focus:ring-danger",
      plain:""
    };
  
    const sizeClasses = {
      sm: "px-4 py-2 text-sm",
      md: "px-6 py-3 text-base",
      lg: "px-8 py-4 text-lg",
    };
  
    const combinedClasses = `${base} ${variantClasses[variant] || variantClasses.primary} ${sizeClasses[size] || sizeClasses.md} ${className}`;

  
    return (
      <button type={type} className={combinedClasses} onClick={onClick}>
        {children}
      </button>
    );
  }